import React from "react";

export const C = {
  navy: "#1C4358", red: "#9C1E22", green: "#2F7D5A", amber: "#B7791F",
  charcoal: "#252221", slate: "#4B5563", line: "#E6EDF2", sky: "#2C6480",
};

export const STATUS_STYLE = {
  draft: { bg: "#EEF2F5", fg: "#4B5563", label: "Draft" },
  pending_review: { bg: "#FEF3C7", fg: "#92400E", label: "Pending review" },
  published: { bg: "#D1FAE5", fg: "#065F46", label: "Published" },
  archived: { bg: "#E5E7EB", fg: "#374151", label: "Archived" },
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString([], { dateStyle: "medium" }); } catch { return iso; }
};

export const StatusBadge = ({ status, testid }) => {
  const s = STATUS_STYLE[status] || STATUS_STYLE.draft;
  return (
    <span data-testid={testid} className="text-[11px] font-semibold px-2 py-0.5 rounded-full"
      style={{ background: s.bg, color: s.fg }}>{s.label}</span>
  );
};

export const AudienceChips = ({ audiences = [] }) => (
  <div className="flex flex-wrap gap-1">
    {audiences.map((a) => (
      <span key={a} className="text-[10.5px] px-1.5 py-0.5 rounded-full border"
        style={{ borderColor: C.line, color: C.slate }}>{a.replace(/_/g, " ")}</span>
    ))}
  </div>
);
